import React from 'react'
import { Edit } from 'react-admin'

import EventForm from './form'

export const EventEdit = (props) => (
  <Edit undoable={false} {...props}>
    <EventForm {...props} />
  </Edit>
)

export default EventEdit
